import { computeAssignedTaskAlertStatus } from "@/modules/performance-tracking/domain/task-alert";
import type { AssignedTaskDTO } from "../api/client";

export type TaskUrgency = AssignedTaskDTO["alertStatus"];

/** ອ່ານຈາກ API (ແຫຼ່ງຄວາມຈິງດຽວກັນກັບເຊີເວີ). */
export function taskUrgencyForTask(t: AssignedTaskDTO): TaskUrgency {
  return t.alertStatus;
}

/** ສຳລັບແຖວທີ່ບໍ່ມີ alertStatus. */
export function taskUrgencyFromDueAndStatus(
  status: string,
  dueDate: string | null,
): TaskUrgency {
  return computeAssignedTaskAlertStatus(status, dueDate);
}
